module.exports = __webpack_public_path__ + "static/media/19-rettssak.28e05014.mp3";